import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'och',
  SignUp: 'Bli medlem',
  LogIn: 'Logga in',
  LOGIN: 'LOGGA IN',
  Close: 'Stäng',
  Ok: 'OK',
  Back: 'Tillbaka',
  He: 'Han',
  She: 'Hon',
  Him: 'Honom',
  Her: 'Henne',
  Find: 'Finn',
  Thanks: 'Tack',
  SingUpLanding: 'Tryck här för att hitta',
  LogInLanding: 'Redan medlem? Logga in här',
  TitleLanding: 'Trött på gamla dejtingsajter?',
  SubTitleLanding:
    'Så är vi! också Upptäck en ny upplevelse på ' +
    config.TITLE +
    ' med dessa funktioner:',
  logInWithApple: 'Logga in med Apple',
  mailIsConfirmed:
    'Grattis! Ditt konto har aktiverats framgångsrikt. Tack för att du har verifierat din e-post. Du kan nu njuta av full tillgång till våra tjänster.',
  SignUpWithEmail: 'Registrera dig med e -post',
  reactivateAccount: 'Återaktivera konto',
  welcomeBack: 'Välkommen tillbaka',
  prevYouDeactivYourAcc: 'Du har tidigare avvaktiverat ditt konto',
  doUwantToReacYourAcc: 'Vill du återaktivera ditt konto',
  yesReactivateMyAcc: 'Ja, återaktivera mitt konto',
  noKeepDeactivated: 'Nej, behåll inaktiverad',
  signUpWithApple: 'Registrera dig med Apple',
  TermsOfService: 'Anvndarvillkor\u00A0\u00A0',
  PrivacyPolicy: 'Integritets\u00A0Policy',
  AntiHumanTraffickingPolicy: 'Policy mot människohandel',
  ContentPolicy: 'Samtycke/Innehåll',
  JoinToday: 'Gå med idag',
  firstName: 'Förnamn',
  yourFirstName: 'Ditt förnamn',
  EmailAddress: 'E-postadress',
  password: 'Lösenord',
  EnterEmailAddress: 'Skriv in epostadress',
  EnterPassword: 'Skriv in lösenord',
  PleaseEnterValidEmail: 'Ange giltig e -postadress',
  PleaseEnterPassword: 'Var snäll och fyll i lösenord',
  LandPageHeader: 'Redo för ett nytt äventyr?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Dating connects ' +
    config.NICHE_SINGULAR +
    ' singlar som letar efter en romantik',
  LandPageLegal: 'Genom att logga in accepterar du vår',
  LandPageAllDevices: 'Finns på alla enheter',
  ForgotYourPassword: 'Glömt ditt lösenord?',
  or: 'eller',
  Save: 'Spara',
  views: 'Visningar',
  view: 'Visning',
  ViewedMyProfile: 'Visade profil',
  ViewProfile: 'Visa profil',
  UnmatchDelete: 'Avmatcha / Ta bort',
  UnmatchDeleteQuestionMark: 'Avmatcha/Ta bort?',
  UnmatchDeleteText:
    'Är du säker på att du vill avmatcha/ta bort? Du har inte längre tillgång till din chatthistorik med ',
  YesUnmatchDelete: 'Ja, Avmatcha/Ta bort',
  IViewed: 'Visade',
  ViewedMe: 'Jag visades',
  LikesMe: 'Gillar mig',
  Mutual: 'Gemensam',
  MyLikes: 'Mina gilla-markeringar',
  Chat: 'Chatt',
  Flirts: 'Flirtar',
  Send: 'Skicka',
  typing: 'skriver',
  UpgradeToVIP: 'Uppgradera till VIP',
  TypeAMessageHere: 'Skriv ett meddelande här',
  FeaturesChat: 'Chatt',
  SendMessagesToWhoYouWant: 'Skicka meddelanden till vem du vill',
  SeeWhoIsInterestedInYou: 'Se vem som är intresserad av dig',
  SeeWhoIsReallyInterestedInYou: 'Se vem som verkligen är intresserad av dig',
  IncreaseYourChancesWithAFlirt: 'Öka dina chanser med en flirt',
  GetDatesFast: 'Få dejt snabbt genom att säga Ja eller Nej',
  FeaturesIncluded: 'Funktioner ingår',
  Matches: 'Matchningar',
  Likes: 'Gilla-markeringar',
  QuickMatch: 'Snabb Match',
  Search: 'Sök',
  Favorite: 'Favorit',
  Favorites: 'Favoriter',
  Browse: 'Bläddra',
  MyProfile: 'Min profil',
  Settings: 'Inställningar',
  // Logout
  LogoutH1: 'Du har loggat ut nu',
  LogoutP: 'Du kommer att saknas...',
  LogoutButton: 'Logga in igen',
  // Unsubscribe
  tooManyEmails: 'För många mejl',
  enterYourEmailBelowToUnsub:
    'Ange din e -postadress nedan för att avsluta prenumerationen',
  unsubscribe: 'Avsluta',
  unsubscribeSuccess: 'Avslutat',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Du får inte längre några mejl från oss',
  unSubByAccident: 'Avanmält av misstag',
  reSubHere: 'Prenumerera igen här',
  helpUsGetBetter: 'Hjälp oss att bli bättre',
  tellUsWhyYouUnSub: 'Berätta varför du avslutade prenumerationen',
  resubscribeSuccessful: 'Prenumererad igen',
  clickHere: 'Klicka här',
  toGoBackToTheSite: 'för att gå tillbaka till webbplatsen',
  pleaseSelectOneOfTheReasonsBelow: 'Välj en av anledningarna nedan',
  notEnoughUsers: 'Inte tillräckligt med medlemmar',
  complicatedToUse: 'Komplicerat att använda',
  notEnoughOptions: 'Inte tillräckligt med alternativ',
  betterAlternatives: 'Bättre alternativ',
  badExperienceWithAnotherUser: 'Dålig erfarenhet av en annan medlem',
  technicalIssues: 'Tekniska problem',
  thanksForYourFeedback: 'Tack för din feedback',
  tapHere: 'Tryck här',
  // Who's online
  WhosOnline: 'Vem är online',
  Recent: 'Senaste',
  ThisWeek: 'Denna vecka',
  MembsWereOnlineRec: 'Medlemmar som var online nyligen',
  MembsWereOnlineWeek: 'Medlemmar som var online denna vecka',
  MembsRecWillAppHere: 'Medlemmar som nyligen var online kommer att visas här',
  MembsThisWeekWillAppHere:
    'Medlemmar som varit online denna vecka kommer att visas här',
  // Browse
  BrowseZero: 'Det finns',
  BrowseZero2: 'Medlemmar',
  BrowseMembersAppear: 'Medlemmar kommer att visas här',
  // Favorites
  MyFavorites: 'Mina favoriter',
  FavoritedMe: 'Lagt till mig som favorit',
  YourFavWillAppHere: 'Dina favoriter kommer att visas här',
  MembHaveFavU: 'Medlemmar som lagt till dig som favorit',
  MembWhoFavU: 'Medlemmar som lagt till dig som favorit visas här',
  NewPasswordSet: 'Nytt lösenord har ställts in. Nu kan du logga in.',
  // Password Recovery
  recoveryTittle: 'Återställning av lösenord',
  recoveryButton: 'Återställ lösenord',
  goBackToLogIn: 'Tillbaka till login',
  recoveryMessage1:
    'Om vi hittar ett konto med den e -postadressen skickas en lösenordsåterställningslänk.',
  NewPassword: 'Nytt lösenord',
  SetNewPassword: 'Ställ in nytt lösenord',
  // Info Line
  NotShared: 'Ej delad',
  // Create Account Email Register
  byCreatingYourAccount:
    'Genom att gå med på webbplatsen godkänner jag villkoren ',
  alsoAgree:
    'Jag godkänner också att ta emot meddelanden, kontouppdateringar och specialerbjudanden via e -post',
  picturesDisclaimer:
    'Bilder används endast för illustrativa ändamål och alla personer som avbildas i innehållet är en modell',
  step: 'Steg',
  // GenderStep
  StepsTitle:
    'Gå med oss och träffa ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Älskare Nu!',
  gender: 'Kön',
  startMeeting: 'Börja träffas nu',
  weNeedInfo: 'Vi behöver bara lite information',
  iAm: 'Jag är:',
  near: 'Nära:',
  seeking: 'Söker:',
  next: 'Nästa',
  viewOtherOptions: 'Visa andra alternativ',
  // LocationStep
  location: 'Plats',
  WhereAreYouLocated: 'Var är din plats?',
  WellFindMatchesInYourArea: 'Vi hittar matchningar i ditt område',
  EnterYourCityOrLocation: 'Ange din ort eller plats:',
  // AgeStep
  age: 'Ålder',
  howOldAreYou: 'Hur gammal är du?',
  enterAgeBelow: 'Ange din ålder nedan',
  ageLabel: 'Ålder:',
  agePlaceholder: 'Din ålder',
  ageError: 'Åldern måste vara mellan < och >',
  EnterYourAge: 'Ange din ålder',
  // UsernameStep
  username: 'Användarnamn',
  chooseUsername: 'Välj ett användarnamn',
  itWillBeYourBio: 'Det kommer att användas på din profilbio',
  usernamePlaceholder: 'Exampel: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Välj ett användarnamn',
  usernameError: 'Detta användarnamn är ogiltigt',
  usernameLabel: 'Användarnamn',
  usernameLabelSmall: '(6-14 Bokstäver och siffror)',
  enterYourNewUsername: `Adja meg új felhasználónevét (e.g. ${getCleanUsername(
    config.NICHE_SINGULAR
  )})`,
  lettersAndNumbersOnly: 'Använd endast bokstäver och siffror',
  useAtLeastOneLetter: 'Använd minst en bokstav',
  // EmailStep
  emailPassword: 'Email/Lösenord',
  youAreDone: 'Du är nästan klar...',
  createYourAccount: 'Skapa ditt konto nedan',
  createAccount: 'Skapa konto',
  emailError: 'Ange en giltig e-postadress',
  passwordError: 'Minsta lösenordslängd är 6 tecken',
  enterYourPassword: 'Ange ditt lösenord',
  useMinChar: 'Använd minst 6 tecken',
  ageMissingHeadline: 'Ålder är obligatorisk',
  EnterYourEmailAddress: 'Ange din e-postadress',
  ChooseAPassword: 'Välj ett lösenord',
  itWiilBeUsedForLogin: 'Den kommer att användas för inloggning',
  // PasswordStep
  choosePassword: 'Välj lösenord',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Ange din e-postadress och välj lösenord',
  // Auto-complete
  EnterYourLocation: 'Ange din plats',
  EnterYourCityOrZipCode: 'Ange din ort eller postnummer nedan:',
  enterCityOrZip: 'Ange din ort eller postnummer',
  Menu: 'Meny',
  More: 'Mer',
  // Matches
  noMatchesFound: 'Inga matchningar',
  wantMoreMatches: 'Vill du ha fler matchningar?',
  tapButtonBelow:
    'Tryck på knappen nedan för att ändra dina matchinställningar',
  editMatchPreferences: 'Redigera Matchningsinställningar',
  // MyLikes
  youHave: 'Du har',
  increaseYourMatches:
    'Öka dina matchningar genom att trycka på knappen "Börja gilla" nedan',
  startLiking: 'Börja gilla',
  // Mutual
  mutualLikes: 'Gemensamma gilla-markeringar',
  // LikesMe
  membersHaveLikedYou: 'Medlemmar har gillat dig',
  // MyViews
  youHaveViewed: 'Du har visat',
  profiles: 'Profiler',
  membersWhoYouViewed: 'Medlemmar som du visade, kommer att visas här',
  // ViewedMe
  memberViewedYou: 'Medlemmar som visat dig',
  memberWhoViewYourProfile: 'Medlem som besöker din profil visas här',
  // Settings
  logout: 'Logga ut',
  general: 'allmän',
  account: 'konto',
  legal: 'rättslig',
  support: 'support',
  matchPref: 'Matchningsinställningar',
  emailPref: 'E-postinställningar',
  privacyStgs: 'Integritetsinställningar',
  reactivateVipMbership: 'Återaktivera VIP-medlemskap',
  youAreVipMember: 'Du är en VIP-medlemr',
  byCancelingYourVip:
    'Genom att säga upp ditt VIP-medlemskap har du inte längre tillgång till följande funktioner när din nuvarande medlemstid löper ut',
  unLimitedMessages: 'Obegränsade meddelanden',
  seeAllPhotos: 'Visa alla foton',
  unlimtedUndo: 'Obegränsat med ångra',
  deactivateAccount: 'Inaktivera konto',
  deleteAccount: 'Ta bort konto',
  showMe: 'Visa mig',
  limitSearchToDistance: 'Begränsa sökningen till avstånd',
  showAges: 'Visa åldrar',
  men: 'Män',
  women: 'Kvinnor',
  toastPrefUpdatedSucc: 'Inställningarna har uppdaterats',
  receiveEmail: 'Få e-post',
  whenSomebodySendsNewMsg: 'När någon skickar ett nytt meddelande till mig',
  whenSomebodyLikesMe: 'När någon gillar mig',
  whenSomebodyVisitMyPof: 'När någon besöker min profil',
  whenNewMembersComeOnline: 'När nya medlemmar är online',
  withDiscountPromotions: 'Med rabattkampanjer',
  whenSomebodyFlirtsMe: 'När någon flörtar med mig',
  whenSomebodyAddsMeToFavorites: 'När någon lägger till mig som favorit',
  whenNearbyMembersComeOnline: 'När medlemmar i närheten går online',
  withNewWaysToMeetSingles: 'Med nya sätt att träffa singlar',
  whenMyFavoritesComeOnline: 'När mina favoriter går online',
  whenNearbyMembersUploadPhoto: 'När medlemmar i närheten laddar upp ett foto',
  whenSomebodyMatchesWithMe: 'När någon matchar med mig',
  whenSomebodyTriesToConnectWithMe: 'När någon försöker ta kontakt med mig',
  notifEmailPauseFor30Days: 'Pausa alla e-postmeddelanden i 30 dagar',
  notifEmailPausedUntil: 'E-postmeddelanden pausade till',
  notifOptions: 'Notis-alternativ',
  notifUpdateSucc: 'Notisar har uppdaterats',
  privacySettingsText1: 'Kontrollera vem som ser din profil',
  privacySettingsText2: 'Välj ett eller flera alternativ nedan',
  importantNotice: 'Viktigt meddelande',
  byDeactivatingYourAccount:
    'Genom att inaktivera ditt konto har du inte tillgång till följande förrän du återaktiverar ditt konto',
  yourMatches: 'Dina matchningar',
  yourMessages: 'Dina meddelanden',
  yourLikes: 'Dina gilla-markeringar',
  yourFavorites: 'Dina favoriter',
  allOtherInfo: 'All annan information som är kopplad till ditt konto',
  yourProfileWillBeHidden:
    'Din profil kommer att döljas för andra medlemmar. Du får inte mejl från oss förrän du återaktiverar ditt konto. Tryck på knappen nedan för att inaktivera ditt konto',
  areYouSure: 'Är du säker?',
  yourAccountWillBeDeact: 'Ditt konto kommer att inaktiveras',
  yesDeactivateAcc: 'Ja, inaktivera konto',
  accountSuccDeact: 'Kontot har inaktiverats',
  byDeletingYourAccount:
    'Genom att radera ditt konto kommer följande information att raderas permanent',
  infoUsedToCreate: 'Information som används för att skapa ditt konto',
  yourPhotos: 'Dina foton',
  yourChatHistory: 'Din chatthistorik',
  thisActionIsNotReversible: 'Denna åtgärd kan inte ångras',
  tapTheButtonBellow: 'Tryck på knappen nedan för att radera ditt konto',
  yesDeleteAccount: 'Ja, ta bort konto',
  accountSuccDelete: 'Kontot har tagits bort',
  byReactivatingYourVip:
    'Genom att återaktivera din VIP -medlemskapsprenumeration debiteras du i slutet av den aktuella faktureringsperioden',
  tapTheButtonToReactivateVip:
    'Tryck på knappen nedan för att återaktivera ditt VIP-medlemskap',
  yourMembershipWillExpire: 'Ditt medlemskap löper ut den',
  yourMembershpWillRenew: 'Ditt medlemskap förnyas den',
  yourVipMembershipWillReactivate: 'Ditt VIP-medlemskap aktiveras igen',
  yesReactivateVip: 'Ja, återaktivera VIP-medlemskap',
  noIveChangedMyMind: 'Nej, jag har ändrat mig',
  membershipSuccessfullyReactivated: 'Medlemskapet återaktiverades',
  membershipSuccessfullyCanceled: 'Medlemskapet avbröts',
  visibilityPreferences: 'Synlighetsinställningar',
  onlyShowMyProfileToPeopleISendMsg:
    'Visa bara min profil för personer som jag skickar ett meddelande till',
  dataManagement: 'Datahantering',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Tryck på knappen "Ladda ner data" nedan för att se din kontodata',
  downloadData: 'Ladda ner data',
  yesDownload: 'Ja, ladda ner',
  yourDataWillBeDownloaded: 'Dina data kommer att laddas ner',
  changePassword: 'Ändra lösenord',
  saveChanges: 'Spara ändringar',
  currentPassword: 'Nuvarande lösenord',
  confirmNewPassword: 'Bekräfta nytt lösenord',
  enterNewPassword: 'Skriv in nytt lösenord',
  passwordNotMatch: 'Lösenordet matchar inte',
  passwordChangedSuccess: 'Lösenordet har ändrats',
  registredAs: 'Registrerad som:',
  userID: 'Användar ID:',
  version: 'Version:',
  // Member
  cancel: 'Annullera',
  reportUser: 'Rapportera medlem',
  blockUser: 'Blockera medlem',
  options: 'Alternativ',
  startConversation: 'Starta en konversation',
  requestPhotoTap: 'Tryck här',
  requestPhotoTapTo: 'för att begära hans foto',
  requestPhotoTapToFemale: 'för att begära hennes foto',
  requestPhoto: 'begär foto',
  photoAlreadyRequested: 'Foto redan begärt',
  youAlreadyRequestedPhoto: 'Du har redan begärt den här medlemmens foto',
  photoRequestSuccessfully: 'Fotoförfrågan skickades',
  tellWhy: 'Berätta varför',
  inappropriatePhotos: 'Olämpliga foton',
  inappropriateMessages: 'Olämpliga meddelanden',
  badOfflineBehavior: 'Dåligt offlinebeteende',
  feelsLikeSpam: 'Varkar vara skräppost',
  reportChildSafetyConcern: 'Rapportera oro för barns säkerhet',
  other: 'Annat',
  report: 'Rapportera',
  reportComment: 'Rapportera kommentar...',
  blockMember: 'Blockera medlem?',
  willNoLongerAppear: 'visas inte längre i din lista över matchningar.',
  yesBlock: 'Ja, blockera medlem',
  noCancel: 'Nej, ångra',
  userReportedSuccessfully: 'Medlem har rapporterats',
  userBlockedSuccessfully: 'Medlem har rapporterats',
  addedToFavorites: 'Lagt till i Favoriter!',
  removedFromFavorites: 'Togs bort från Favoriter!',
  sendAMessage: 'Skicka ett meddelande',
  sendUserAMessage: 'Skicka {user} ett meddelande',
  wellYouveComeThisFar:
    'Du har väl kommit så här långt, kan lika gärna säga något',
  chatWith: 'Chatta med',
  outOfFlirts: 'Utan flirtar',
  untilYouCanSend: 'Tills du kan skicka en flirt igen.',
  wantToMakeSure: 'Vill vara säker',
  seesYou: 'ser dig?',
  goVipGetFlirts: 'Bli VIP och få {num_of_flirts} flirtar om dagen!',
  getMoreFlirts: 'Skaffa fler flirtar',
  noNotThisTime: 'Nej, inte just nu',
  flirtSent: 'Flirt skickad och gillad',
  memberNotSharedAboutMe: 'Denna medlem har inte delat information om sig',
  dontWait: 'Vänta inte',
  chooseFlirt: 'Välj en flirt:',
  sendFlirt: 'Skicka en flirt',
  flirtIsSent: 'Flirt skickad',
  // Chats
  chats: 'Chatt',
  sentMessages: 'Skickade meddelanden',
  yourConversations: 'Dina konversationer med andra medlemmar visas här',
  yourSentMessages: 'Dina skickade meddelanden till andra medlemmar visas här',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "Du kan inte skicka chattmeddelanden om du inte är VIp-medlem eller om 'Happy Hour' är aktiv",
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Skicka meddelanden gratis',
  endsIn: 'Slutar om:',
  happyHourTonightAt: 'Ikväll kl',
  happyHourTodayAt: 'Idag kl',
  // Contact us
  ContactUs: 'Kontakta\u00A0oss',
  ContactUsSupport: 'Kontakta oss / support',
  WhatIsYourEmail: 'Vad är din email adress?',
  HowCanWeHelpU: 'Hur kan vi hjälpa dig?',
  WriteMsg: 'Skriv meddelande...',
  SendMsg: 'Skicka meddelande',
  EnterMsg: 'Skriv meddelande.',
  AlertMsgSentSuccessfully: 'Tack! Meddelande skickat.',
  ToastMsgSentSuccessfully: 'Meddelande skickat',
  Subject: 'Ämne',
  subject0: 'Allmänna problem',
  subject1: 'VIP-medlemskap',
  subject2: 'Bedrägerierapport',
  subject3: 'Ta bort',
  subject4: 'Radera konto',
  subject5: 'Annat',
  // Search
  refineSearch: 'Förfina sökning',
  iamDoneRefining: 'Jag är klar med förfining',
  showAdvanced: 'Visa avancerade alternativ',
  hideAdvanced: 'Dölj avancerade alternativ',
  cancelSearch: 'Avbryt Förfina sökning?',
  youWillLoseYourChanges:
    'Du kommer att förlora alla ändringar i dina sökkriterier',
  yesLeavePage: 'Ja, lämna sidan',
  noContinueRefining: 'Nej, fortsätt förfina',
  zeroMembersFound: 'Medlemmar hittade',
  tap: 'Tryck',
  // tapHere: 'Tryck här,
  // uploadAPhotoHere: 'Ladda upp ett foto här',
  toDisplayPreviousMembers: 'för att visa tidigare medlemmar.',
  toEditCurrentFilters: 'för att redigera dina nuvarande filter.',
  resetSearch: 'Återställ sökning',
  tryAgain: 'Försök igen',
  mile: 'Mil',
  miles: 'Mil',
  noUsers: 'Inga medlemmar',
  // Quick Match Button text
  undo: 'Ångra',
  pass: 'Pass',
  like: 'Lajk',
  profile: 'Profil',
  undoNotAvailable: 'Ångra ej tillgängligt',
  nothingToUndo: 'Det finns inget att ångra.',
  thisIsTheFirstUser: ' Detta är den första användaren.',
  undoOnlyLastAction: 'Du kan bara ångra den senaste åtgärden.',
  dismissAd: 'Avfärda',
  seeMoreHere: 'Se mer här',
  tryChangingYourPreferences: 'Ändra dina preferenser.',
  errorOnInviteActionTitle: 'Fel på Quick Match',
  // It's Match
  itsMutual: 'Det är ömsesidigt',
  youAndMemberLikeEachOther: 'Du och {member} gillar varandra!',
  seeMoreMatches: 'Se fler matchningar',
  // My Profile
  edit: 'Redigera',
  aboutMe: 'Om mig',
  youHaveNotSharedAbout: 'Du har ännu inte delat din Om mig',
  appearance: 'Utseende',
  situation: 'Situation',
  addPhoto: 'Lägg till profilfoto',
  // Edit Profile
  editProfile: 'Redigera profil',
  reset: 'Återställ',
  dob: 'Födelsedatum',
  youWillLoseYourChangesProfile:
    'Du kommer att förlora alla nuvarande ändringar du gjort i din profil',
  cancelEdit: 'Avbryt redigeringen av din profil?',
  noContinueEditing: 'Nej, fortsätt redigera',
  invalidMonth: 'Ogiltig månad',
  invalidDay: 'Ogiltig dag',
  invalidAge: 'Du måste vara mellan {min} och {max} år',
  invalidFebruar: 'Februari kan ha högst 28 eller 29 dagar',
  invalid30Day: 'Denna månad kan ha högst 30 dagar',
  invalid31Day: 'Denna månad kan ha högst 31 dagar',
  invalidLocation: 'Platsen är ogiltig, välj plats från rullgardinsmenyn',
  locationUpdated: 'Platsen har uppdaterats',
  setAsMainPhoto: 'Välj som huvudfoto',
  changeAsMainPhoto: 'Ändra till huvudfoto',
  deletePhoto: 'Ta bort foto',
  areSureDeletePhoto: 'Är du säker på att du vill ta bort det här fotot?',
  noKeepPhoto: 'Nej, behåll foto',
  yesDeletePhoto: 'Ja, ta bort foto',
  editPhoto: 'Redigera Foto',
  profileUpdated: 'Profil uppdaterades',
  secondaryImageAlertText:
    'Denna bild är märkt som sekundär av kundsupport och kan därför inte ställas in som profilfoto.',
  reviewImageAlertText:
    'Den här bilden är ännu inte godkänd av vår kundsupport. Försök senare.',
  pendingReview: 'Väntar på granskning',
  // missing location
  locationReq: 'Platsbegäran',
  pleaseEnterLocation: 'Ange din plats nedan.',
  withoutItOther: 'Utan det, andra medlemmar',
  cantSee: 'kan inte se,',
  likeOrMessage: 'gilla eller messa dig.',
  submit: 'Skicka in',
  // missing username
  completeYourProfile: 'Komplettera din profil',
  itWillBeUsedOnYourProfileBio: 'Det kommer att användas på din profilbio',
  userNameLettersAndNumbers: '(6-14 bokstäver och siffror)',
  submitUsername: 'Skicka in användarnamn',
  unknownError: 'Okänt fel har inträffat',
  confirmUsername: 'Bekräfta användarnamn',
  orChooseNewOne: 'Eller välj ett nytt',
  // missing username and location
  welcomeToSite: 'Välkommen till ' + config.TITLE,
  yourAccountIsNowActive: 'Ditt konto är nu aktivt!',
  itsGreatToHaveYou:
    'Det är härligt att ha dig här som medlem på vår webbplats och ser fram emot att hjälpa dig att hitta det perfekta\u00A0matchning.',
  // error
  somethingWentWrong: 'Något gick fel',
  networkError: 'Nätverksfel! Försök senare.',
  // invalid Token
  invalidToken: 'Din session har gått ut. Vänligen logga in igen',
  // rejected Username
  rejectedUsername: 'Avvisat användarnamn',
  // missing password
  missingPassword: 'Du är nästan klar...',
  missingPasswordText: 'Ställ in ditt lösenord nedan',
  missingPasswordPlaceholder: 'Minst 6 tecken',
  submitPassword: 'Välj lösenord',
  // missing email
  missingEmail: 'Vi saknar din e-post',
  missingEmailText:
    'Ange din e -postadress nedan för aviseringar när du får nya meddelanden, gilla-markeringar, matchningar och personer som ser din profil.',
  submitEmail: 'Skicka in e-post',
  // Move and Scale
  moveAndScale: 'Flytta och förstora',
  crop: 'Beskära',
  uploadError: 'Bilduppladningsfel',
  whoops: 'Oj då',
  itSeemsThatIsTaking:
    'Det verkar som att det tar längre tid än vanligt att ladda upp ett foto. Var god försök igen.',
  // Missing Photo
  photoRequest: 'Fotoförfrågan',
  wait: 'Vänta...',
  yourMissingPhoto: 'Du saknar ett foto',
  membersWithoutPhotos: 'Medlemmar utan foton har 65% färre',
  likelyToReceive: 'chanser att få likes och meddelanden',
  submitPhoto: 'Skicka in foto',
  takePhoto: 'Ta bild',
  chooseFromLibrary: 'Välj från fotobibliotek',
  // Missing Gender
  youLookingFor: 'Vad letar du efter',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Du är nästan klar',
  iWouldLikeToGetSpecOffers:
    'Jag skulle vilja få specialerbjudanden, rabatter och månadsförsäljning via e -post',
  iHaveReadAndAgreeToPP: 'Jag har läst och godkänner villkoren',
  ByJoiningTheSiteAgreeTos: 'Genom att gå med på webbplatsen godkänner jag',
  optional: 'Frivilligt',
  required: 'Obligatoriskt',
  continue: 'Fortsätt',
  // coreg
  toGetStarted: 'För att starta',
  tapHereToGetStarted: 'Tryck här för att komma igång',
  hello: 'Hej',
  // Upgrade Modal
  membershipStatus: 'Medlemsstatus',
  upgradeToVipChoosePlan: 'Uppgradera till VIP.',
  wantUnlimitedMessages: 'Vill du ha obegränsat med meddelanden?',
  wantToReply: 'Vill du svara på %gender%? Bli VIP!',
  getUnlimitedMessages: 'Få obegränsade meddelanden. Välj en plan:',
  needToUndoMistake: 'Behöver du ångra ett misstag? Bli VIP!',
  getUnlimitedUndos: 'Få obegränsat med ångra - Välj en plan:',
  whoViewedYourProfile: 'Vem besökte din profil? Ta reda på det!',
  peopleViewedYourProfile: 'Medlemmar som besökte din profil',
  chooseVipPlanToSeeThem: 'Välj en VIP-plan och se dem:',
  wantToSeeWhoFavoritedYou: 'Vill du se vem som lagt till dig till favoriter?',
  peopleFavoritedYou: 'Medlemmar som lagt till dig till favoriter',
  wantToSeeWhoLikesYou: 'Vill du se vem som gillar dig?',
  peopleLikedYou: 'Medlemmar som gillar dig',
  youAreBasic: 'Du är en grundmedlem',
  wantToUnlockPhotos: 'Vill du låsa upp alla foton?',
  wantMoreFlirts: 'Vill du ha 5 flörtar om dagen?',
  vipMembershipFeatures: 'VIP-Premium-medlemsfunktioner inkluderar:',
  vipMembershipFeaturesMobile: 'VIP-medlemmar har:',
  unlimited: 'Obegränsat med',
  messaging: 'Meddelanden',
  meetSomeoneTonight: 'Uppgradera nu - träffa någon i kväll!',
  chooseVipPlanBelow: 'Välj en VIP-plan nedan:',
  messagingSub: 'Fortsätt chatta med dina matchningar',
  viewedSub: 'Se vem som besökt din profil',
  likesMeSub: 'Upptäck vem som gillade din profil',
  unlockPhotosSub: 'Se alla medlemmars foton',
  favoritedMeSub: 'Se vem som verkligen är intresserad av dig',
  moreFlirtsSub: 'Öka dina chanser med 5 flirtar om dagen',
  goPrivateSub: 'Kontrollera vem som ser din profil',
  undoSub: 'Gjorde du ett misstag? Ångra din svepning!',
  select: 'Välj',
  vipMembersReceive: 'VIP-MEDLEMMAR FÅR:',
  chooseYourPlan: 'VÄLJ DIN PLAN:',
  enterPaymentDetails: 'ANGE DIN BETALNINGSDETALJER:',
  creditCard: 'Kreditkort',
  yourSubscriptionWillRebill:
    'Din prenumeration startas automatiskt om till ett {0} medlemskap på {1} den {2} och förnyas var {0} tills den sägs upp. Du kan avbryta när som helst via dina kontoinställningar.',
  byTappingButtonBelow: 'Genom att trycka på knappen nedan godkänner du',
  andAuthorizeToCharge:
    'och ge oss tillstånd att debitera ditt %CARD_TYPE% nu och vid varje förnyelse.',
  continueToPayPal: 'Fortsätt till PayPal för att slutföra ditt köp.',
  proceedToPayPal: 'Fortsätt till PayPal',
  limitedTimeOffer: 'Tidsbegränsat erbjudande',
  promoHeader: '{date} VIP-medlemskap prova-på för {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} månad(er)',
  promoSubHeaderText:
    'Detta är ett exklusivt engångserbjudande för nya medlemmar',
  promoButtonText: 'Endast {price} - {date} prova-på',
  promoRebillsText:
    '*Förnyas {date} for {price} om VIP-medlemskap inte avbryts före provperiodens slut*',
  accessToAllPhotos: 'Tillgång till alla foton är aktiv',
  toPremiumUsers: 'endast till Premium-medlemmar.',
  unlimitedMessaging: 'Obegränsat antal meddelanden är tillgängligt',
  upgradeTodayAndSendMessage:
    'Uppgradera idag för att läsa och svara på meddelanden från',
  upgradeTodayAndSeePhotos: 'Uppgradera idag för att komma åt alla foton av',
  mostPopular: 'Mest populär',
  notSuitableForCreditCard: 'Ej lämpligt att betala med kreditkort?',
  weAreAccepting: 'Vi accepterar ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Vi har ett erbjudande till dig:',
  discount: 'rabatt',
  onVipMembership: 'på ett VIP-medlemskap!',
  tapHereToSave: 'Tryck här för att spara 50 %!',
  toUnlockFeatures: 'för att låsa upp alla premiumfunktioner',
  upgrade: 'Uppgradera',
  upgradeNow: 'Uppgradera nu',
  // Invalid Tagline
  invalidTaglineHeadline: 'Beskrivning avvisad',
  invalidTaglineTitle: 'Texten i avsnittet "Om mig" godkändes inte.',
  invalidTaglineReason: 'Anledning: ',
  invalidTaglineButton: 'Uppdatera beskrivning',
  // Invalid Tagline
  photoRejectedHeadline: 'Foto avvisades',
  photoRejectedTitle: 'Vi beklagar...',
  photoRejectedParagraph:
    'En eller flera av dina uppladdade foton godkändes inte.',
  photoRejectedReason: 'Anledning: ',
  photoRejectedButton: 'Skicka in nytt foto',
  viewed: 'Visad',
  myProfile: 'Min profil',
  unlock: 'Lås upp',
  allPhotos: 'Alla foton',
  undos: 'Ångra',
  moreFlirts: 'Fler flirtar',
  goPrivate: 'Gå privat',
  monthFor: 'Månad',
  monthsFor: 'Månader',
  mo: 'må',
  month: 'månad',
  months: 'månader',
  monthly: 'månatlig',
  billed: 'faktureras',
  every: 'varje',
  saveUpTo: 'Spara upp till',
  trialFor: 'Prova-på i',
  day: 'dag',
  days: 'Dagar',
  free: 'gratis',
  trialRebillsAt: 'prova-på omfaktureras på',
  per: 'per',
  best: 'Bästa',
  value: 'Värden',
  // Checkout
  planSelected: 'Plan vald',
  paymentOption: 'Betalningssätt',
  billingDetails: 'Fakturaspecifikation',
  payByCard: 'Betala med kort',
  creditOrDebitCard: 'Betala med kredit- eller bankkort',
  payWith: 'Betala med',
  pay: 'Pay',
  pal: 'Pal',
  for: 'för',
  promoRebillsAt: 'prova på omfaktureras på',
  chooseMembershipPlan: 'Välj din medlemsplan nedan',
  choosePaymentOption: 'Välj ditt betalningsalternativ nedan',
  enterCardDetails: 'Ange dina kortuppgifter nedan',
  nameOnCard: 'Namn på kort',
  enterFullName: 'Ange fullständigt namn här',
  creditCardNumber: 'Kortnummer',
  cardNumber: 'Kortnummer',
  enterCardNumberHere: 'Ange kortnummer här',
  expirationDate: 'Utgångsdatum',
  cvv: 'CVV/säkerhet',
  pleaseEnterCvv: 'Ange ditt CVV',
  forYourPrivacyYouAreBilled: 'För din integritet faktureras du diskret som',
  byCompletingThisTransaction:
    'Genom att slutföra denna transaktion intygar du att du är minst 18 år gammal och att du godkänner',
  submitAndUpgrade: 'Skicka in och uppgradera till VIP',
  thisIsSecurePage: 'Detta är en säker sida.',
  dataTransferIsEncrypted: 'Dataöverföring är krypterad för säkerhet och skydd',
  tellUsYourFullName: 'Berätta för oss ditt fullständiga namn som på kortet',
  andManyOthers: 'och många andra',
  youMissedANumber: 'Det verkar som att du råkade skriva in en fel siffra.',
  pleaseEnterYourCreditCard: 'Var god och fyll i ditt kreditkortsnummer',
  pleaseEnterValidCreditCard: 'Ange ett giltigt kreditkortsnummer',
  pleaseEnterMonth: 'Ange månad',
  pleaseEnterValidMonth: 'Ange giltig månad',
  pleaseEnterYear: 'Ange år',
  pleaseEnterValidCvv: 'Ange giltigt CVV',
  pleaseAgreeToTos: 'Godkänn användarvillkoren',
  thanksForBeingVip: 'Tack för att du är VIP-medlem',
  subscriptionUnavailable:
    'Prenumeration inte tillgänglig eftersom du redan är VIP',
  onTheBackOfCard: 'På baksidan av ditt kort kan du',
  findYour: 'finna ditt',
  cvvCvc: 'CVV/CVC',
  codeHere: 'kod här.',
  hurryUp: 'Skynda dig!',
  thisOfferExpires: 'Detta erbjudande löper ut om:',
  youAreInLuck: 'Du har tur!',
  thisPromoGotExtended:
    'Denna kampanj förlängdes. Nyttja den snabbt, eftersom vi kan ta ner detta erbjudande när som helst nu.',
  forYour: 'För din',
  privacy: 'integritet',
  youAreBilled: 'du faktureras',
  discreetly: 'diskret',
  as: 'som',
  specialOffer: 'Specialerbjudande',
  membershipInfo: 'Medlemsinformation',
  // Success Upgrade
  successUpgrade: 'Uppgraderingen lyckades',
  welcomeToVip: 'Välkommen till VIP!',
  youHaveSuccessfullyUpgraded: 'Du har uppgraderat till en',
  vipPremiumMembership: 'VIP-Premium-medlemskap',
  importantInfo: 'Viktig information!',
  pleasePrintThisPage:
    'Skriv ut den här sidan eller skriv ner följande information. Du kommer att behöva detta i framtiden för att komma åt eller ändra din medlemsinformation.',
  yourCreditCardBilled: 'Ditt kredit-/bankkort debiteras diskret som',
  yourPayPalCardBilled: 'Ditt PayPal-konto debiteras diskret som',
  youWillBeDicreetlyBilled: 'Du kommer att debiteras diskret som :',
  membershipPurchased: 'Medlemskap köpt:',
  billingTerms: 'Faktureringsvillkor:',
  vipPremium: 'VIP-Premium',
  total: 'Total',
  vip: 'VIP',
  trial: 'Prova-på',
  yourInfo: 'Din information:',
  fullName: 'Fullständiga namn:',
  pleaseContactSupport: 'Kontakta supporten om du har några faktureringsfrågor',
  billingSupport: 'Faktureringssupport:',
  billingPhone: 'Faktureringstelefon:',
  clickToAccessVip: 'Klicka för att komma åt VIP-funktioner',
  tapToAccessVip: 'Tryck för att komma åt VIP-funktioner',
  thirtyDays: '30 dagar',
  // Process Payment
  processPayment: 'Vänta, vi behandlar din betalning...',
  paymentProcessingError: 'Payment Processing Error!',
  // Error Component
  serviceUnavailable: 'Tjänsten tillfälligt otillgänglig',
  pleaseTryLater: 'Försök senare',
  // Another Client
  isOpenInAnotherWindow:
    'är öppet i ett annat fönster. Du kan stänga det här fönstret.',
  useInThisWindow: 'Använd det här fönstret',
  // modal alert merging
  greatNews: 'Goda nyheter,',
  weAreHappy: ' Vi är glada att kunna meddela det, träder i kraft idag, ',
  bli: '{old_site} och {new_site} har blivit en stor sajt: {new_site}! ',
  thisMeans:
    ' Detta innebär ett större community för alla våra medlemmar, fler matchningar och större chanser att hitta någon speciell.',
  dontWorry:
    'Oroa dig inte, för dig som är vår medlem förändras ingenting. Din inloggningsinformation, profilinformation och historik har överförts automatiskt, så du kan fortsätta där du slutade. ',
  // ads
  ad: 'Annons',
  sponsored: 'SPONSRAD',
  findNiche:
    'Finn ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche: 'Möt ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Möt' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Singel ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Finn ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Dejta' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romantik',
  adsRandomTextLonelyNiche:
    'Ensam ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Kärlek',
  adsRandomTextWhantNiche:
    'Vill ha' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Dejter',
  adsRandomTextMoreNiche:
    'Fler' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Söker ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Nu?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Singlar',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Cross\u00ADdresser',
  genderCouple: 'Par',
  genderDom: 'Domme',
  genderFem: 'Femdom',
  genderBiCouple: 'Bi-par',
  genderSugarMale: 'Sugar Baby Man',
  genderSugarBaby: 'Sugar Baby',
  genderHotWife: 'Hetfru/\n\u00ADPar',
  genderMan: 'Man',
  lookingFor: 'söker en',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    'vi skulle vilja få lite mer information om dig så att vi kan hitta andra singlar som matchar dig',
  howTallAreYou: 'Hur lång är du?',
  UseSliderHeight: 'Använd skjutreglaget för att ange din höjd',
  WhatIsYourEthnicity: 'Vilken är din etnicitet?',
  specifyYourBodyType: 'Ange din kroppstyp',
  whatYouLookingFor: 'Berätta om din perfekta matchning',
  idealMatchesAge: 'Vilken är din perfekta ålder',
  howFarAway:
    'Hur långt skulle du vara villig att resa för att träffa din perfekta matchning?',
  useSliderDistance: 'Använd skjutreglaget för att ange avståndet',
  toHaveYourProfile: 'Berätta för andra medlemmar om dig själv...',
  writeSomethingAboutYourself:
    'Skriv något intressant om dig själv, något som beskriver dig bäst',
  uploadAPhoto: 'Ladda upp ett foto',
  thisIsImportant: 'Detta är den viktigaste funktionen i din profil!',
  youOnlyHave: 'Du har bara 1 chans att göra ett första intryck.',
  tipPhoto:
    'Tips: Foton ska vara aktuella, bara du ska vara med och markera dina bästa egenskaper för bästa resultat!',
  iUploadLater: 'Jag laddar upp ett foto senare...',
  congratulations: 'Grattis...',
  yourProfileUpdated:
    'Din profil har uppdaterats och du är ett steg närmare att hitta din perfekta matchning.',
  specialOfferNewMembers:
    'Som ett specialerbjudande för nya medlemmar ger vi dig 25% rabatt på våra ordinarie medlemspriser.',
  get25OffNow: 'Få 25 % rabatt nu!',
  youWillBeRedirected: 'du kommer att omdirigeras till uppgraderingssidan om',
  seconds: 'sekunder',
  aNewMember: 'Som ny medlem kvalificerar du dig för en',
  get: 'Få',
  initialOff: '25 % rabatt',
  selectedMembership: 'ditt valda medlemskap',
  selectYourMembership: 'Välj ditt medlemsalternativ',
  newPrice: 'Nytt pris',
  oldPrice: 'Gammalt pris',
  iDontWantToPayLess: 'Nej tack, jag vill inte betala mindre.',
  addPhotoOnboarding: 'Lägg till foto',
  uploadAnotherPhoto: 'Ladda upp ytterligare ett foto',
  finish: 'Slutför',
  ifYourDoneUploadingPhotos: 'Om du har laddat upp foton',
  // california
  CCPATitle: 'Sälj inte min personliga information',
  CCPAPersonal: 'Min personliga information',
  youHaveAlreadyOptedOut: 'Du har redan valt bort.',
  // TransactionProgress
  transactionProgress: 'Transaktionsprogression',
  checkingSpecialOffers: 'Kontrollerar specialerbjudanden...',
  initializingTransaction: 'Påbörjar transaktionen...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Grattis!',
  youAreQualified: 'Du har kvalificerat dig för ett specialerbjudande!',
  toAcceptThisOffer:
    'För att acceptera detta erbjudande, tryck på Fortsätt nedan:',
  noThanksIDontWant: 'Nej tack, jag vill inte betala mindre.',
  forYourConvenience: 'För din bekvämlighet kommer du debiteras',
  on: 'den',
  andEvery: 'och varje',
  daysThereafter: 'dagar därefter, om den inte avbokas.',
  off: 'av',
  yourSelectedMembership: 'ditt valda medlemskap.',
  // Transaction Declined
  transactionDeclined: 'Transaktionen nekad',
  yourCreditCardWasNotApproved:
    'Ditt kreditkort godkändes inte för vårt specialerbjudande.',
  butWait: 'men VÄNTA... här är ytterligare ett specialerbjudande',
  tryA: 'Prova',
  forOnly: 'för endast',
  acceptOffer: 'Acceptera erbjudande',
  membership: 'Medlemskap',
  // Measure System
  measureSystem: 'Mätsystem',
  imperial: 'Kejserligt',
  metric: 'Metriskt',
  // kink cam banner
  viewNow: 'Visa nu',
  youGotAFree: 'Du fick en gratis',
  // receipt page
  bonusMembership: 'Bonusmedlemskap',
  membersLoginArea: 'Login för medlemmar',
  // language
  language: 'Språk',
  // OneClick
  signInFromReferal: 'Logga in med din profil från hänvisande webbplats',
  siteWouldLikeToAccess:
    config.TITLE +
    ' vill ha tillgång till följande information för att registrera dig på denna webbplats:',
  permissionsToAccess:
    'Namn, e -post, födelsedatum, plats och grundläggande dejtingprofilinformation',
  iConsentToDetailsAndRegister:
    'Jag godkänner att dessa uppgifter används för att registrera min profil och bekräftar att jag godkänner ',
  allow: 'Godkänn',
  byClickingAllow:
    'Genom att klicka på GODKÄNN godkänner du att dessa uppgifter används av ' +
    config.TITLE +
    ' för att registrera dig på dejtingsajten och bekräfta att du godkänner villkoren och villkoren som är länkade nedan. Alternativt kan du använda vår',
  standardRegistrationForm: 'Standardformulär för registrering',
  // SpecialOffer2x
  getFreeMembership: 'Få ett GRATIS medlemskap på {0}',
  doubleYourChances: 'Fördubbla dina chanser att träffa någon',
  weHavePartnered:
    'Vi har samarbetat med {0} för att öka våra medlemmars chanser att hitta en match. När du klickar på knappen ovan skapar vi automatiskt en 100% GRATIS PROFIL på {0} och omdirigerar dig till medlemsområdet så att du kan börja söka i deras databas efter potentiella matchningar.',
  congratulationsYouGotFree:
    'Grattis, du fick GRATIS medlemskap på {site_name}.',
  toGetLoggedInto: ' för att logga in på sidan.',
  // RefundCreditCard
  refundCreditCard: 'Återbetalning med nytt kreditkort',
  refundCreditCardSuccess: 'Din begäran om återbetalning har skickats.',
  // Nearby Connect
  nearbyConnect: 'Närliggande Connect',
  nearbyDecline: 'Nej tack, jag vill inte skicka det nu, jag gör det senare.',
  introduceMyself: 'Introducera mig själv',
  distance: 'Avstånd',
  anyDistance: 'Vilket avstånd som helst',
  message: 'Meddelande',
  typeYourMessageHere: 'Skriv ditt meddelande här',
  sendThisToMyNewMatches:
    'Skicka även detta till alla nya matcher när de går med',
  successNearbyConnect: 'Du har konfigurerat Nearby Connect',
  nearbyConnectTitle:
    'Kom i kontakt med hundratals medlemmar direkt! Endast användare som matchar din profil kommer att få dessa meddelanden. Skriv ditt meddelande nedan för att komma igång:',
  nearbyConnectAlert:
    'Nearby Connect-meddelanden är unika meddelanden från andra riktiga medlemmar som kan vara din perfekta match. Dessa meddelanden skickas automatiskt endast till användare som matchar den användarprofilen',
  nearbyUnavailable:
    'Tyvärr, NearbyConnect-funktionen är inte tillgänglig för tillfället. Denna funktion kan användas en gång per 30 dagar. Tack för att du förstår.',
  nearbyFeatureUsed: 'Du använde NearbyConnect-funktionen för {date}.',
  toKeepNearbyFree:
    'För att hålla NearbyConnect gratis begränsar vi den till endast en introduktion var 30:e dag.',
  ifYouLikeToBeIntroduced:
    'Om du vill bli introducerad för fler medlemmar, kom tillbaka för {date}.',
  nearbyConnectValentineTitle: 'Alla hjärtans special',
  nearbyConnectValentineText1:
    'Alla hjärtans dag närmar sig. Under en begränsad tid låter vi dig skicka en ',
  nearbyConnectValentineText2: 'GRATIS introduktionsmeddelande ',
  nearbyConnectValentineText3:
    'till hundratals användare som matchar dina preferenser. Skriv bara ditt meddelande nedan för att komma igång:',
  // supscription status
  subscriptionStatus: 'Prenumerationsstatus',
  subscritpionStatusManageLink1: 'Grattis! Du är en VIP-medlem. Besök ',
  subscritpionStatusManageLink2: 'för att hantera din prenumeration.',
  subscriptionUpgradeLink1: 'Du är en grundläggande medlem. ',
  subscriptionUpgradeLink2: 'Uppgradera till VIP nu!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Hantera Nearby Connect',
  sendNewNearbyConnectMessage: 'Skicka nytt NearbyConnect-meddelande',
  activeUntil: 'Aktiv till',
  sendToNewJoins: 'Skicka till nya medlemmar',
  update: 'Uppdatering',
  disable: 'Inaktivera',
  nearbyConnectUpdated: 'Nearby Connect har uppdaterats',
  nearbyConnectWillBeAvailable:
    'Nearby Connect kommer att vara tillgänglig för dig nästa gång ',
  canChangeMessageOn: 'Kan ändra meddelande på',
  getInTouchWith:
    'Kom i kontakt med hundratals medlemmar direkt! Endast användare som matchar din profil kommer att få dessa meddelanden.',
  // Cookie Consent
  cookieConsentText:
    'Webbplatsen använder cookies. Genom att fortsätta att navigera på webbplatsen samtycker du uttryckligen till att använda cookies.',
  cookieConsentDetailsLinkText: 'Detaljer',
  cookieConsentButtonText: 'jag förstår',
  cookieConsentDeclineButtonText: 'stänga',
  cookieTitle: 'Denna webbplats använder cookies',
  cookieSubTitle:
    'Vi använder cookies och andra spårningstekniker för att förbättra din webbupplevelse på vår webbplats, för att visa dig personligt innehåll och riktade annonser, för att analysera vår webbplatstrafik och för att förstå var våra besökare kommer ifrån.',
  cookieAcceptAllCookies: 'Acceptera alla',
  cookieDeclineAllCookies: 'Avvisa alla',
  cookieManagePreferences: 'Ändra mina inställningar',
  cookieClosePreferences: 'Stäng Inställningar',
  cookieNecessaryTitle: 'Nödvändig',
  cookieNecessaryDescription:
    'Dessa cookies är nödvändiga för att ge dig tjänster som är tillgängliga via vår webbplats och för att du ska kunna använda vissa funktioner på vår webbplats. Utan dessa cookies kan vi inte erbjuda dig vissa tjänster på vår webbplats.',
  cookieActiveText: 'Aktiva',
  cookieAlwaysActiveText: 'Alltid aktiv',
  cookieInactiveText: 'Inaktiv',
  cookieFunctionallityTitle: 'Funktionalitet',
  cookieFunctionallityDescription:
    'Dessa cookies används för att ge dig en mer personlig upplevelse på vår webbplats och för att komma ihåg val du gör när du använder vår webbplats. Vi kan till exempel använda funktionalitetscookies för att komma ihåg dina språkinställningar eller komma ihåg dina inloggningsuppgifter.',
  cookieAnalyticsTitle: 'Analytics',
  cookieAnalyticsDescription:
    'Dessa cookies används för att samla in information för att analysera trafiken till vår webbplats och hur besökare använder vår webbplats. Till exempel kan dessa cookies spåra saker som hur länge du spenderar på webbplatsen eller de sidor du besöker, vilket hjälper oss att förstå hur vi kan förbättra vår webbplats för dig. Informationen som samlas in genom dessa spårnings- och prestandacookies identifierar inte någon enskild besökare.',
  cookieMarketingTitle: 'Marknadsföring',
  cookieMarketingDescription:
    'Dessa cookies används för att visa reklam som sannolikt kommer att vara av intresse för dig baserat på dina surfvanor. Dessa cookies, som serveras av våra innehålls- och/eller reklamleverantörer, kan kombinera information som de samlat in från vår webbplats med annan information som de självständigt har samlat in om din webbläsares aktiviteter över deras nätverk av webbplatser. Om du väljer att ta bort eller inaktivera dessa inriktnings- eller reklamcookies kommer du fortfarande att se annonser men de kanske inte är relevanta för dig.',
  cookieOtherTitle: 'Övrig',
  cookieOtherDescription: 'Några andra kakor',
  cookieSavePreferences: 'Spara inställningar och stäng',
  cookiePreferencesTitle: 'Välj dina inställningar',
  manageCookies: 'Hantera cookies',
  cookiesViewDetails: 'Visa detaljer',
  cookiesProviders: 'Cookies-leverantörer',
  cookiesYahoo: 'Används av Yahoo för innehåll och reklamanpassning.',
  cookiesGoogleDetectSpam:
    'Används för att upptäcka spam, bedrägerier och missbruk.',
  cookiesGoogleAds:
    'Används för att anpassa Google-annonser baserat på senaste sökningar och interaktioner.',
  years: 'år',
  year: 'år',
  cookiesGoogleAdDelivery:
    'Används för att tillhandahålla annonsvisning eller retargeting.',
  cookiesGoogleUseOurSite:
    'Cookie används för att samla in information om hur besökare använder vår webbplats.',
  cookiesGoogleDistinguishUsers: 'Används för att särskilja användare.',
  cookiesGoogleCrossSite:
    'Denna cookie används för att förhindra webbläsaren från att skicka denna cookie tillsammans med förfrågningar över webbplatser.',
  cookiesGoogleUniqueIdTracking:
    'Dessa cookies använder en unik identifierare för spårningsändamål.',
  cookiesGoogleProtectData:
    'Säkerhetscookie för att skydda en användares data från obehörig åtkomst.',
  cookiesGoogleTrackConversions:
    'Används för att lagra och spåra omvandlingar.',
  cookiesBingAds:
    'Denna cookie gör det möjligt att visa relevanta annonser till besökare.',
  cookiesBingTracking:
    'Microsoft User Identifier-spårningscookie som används av Bing Ads.',
  cookiesBingTrackingAdvertising:
    'Detta är en spårningscookie som används av Microsoft Bing-annonsering för att vi ska kunna interagera med en besökare som tidigare har besökt vår webbplats.',
  cookiesBingClarityID:
    'Behåller Clarity User ID och preferenser, unika för den webbplatsen tillskrivs samma användar-ID.',
  cookiesBingClarityMultiple:
    'Kopplar samman flera sidvisningar av en användare till en enda Clarity-sessionsinspelning.',
  cookiesFacebookTracking:
    'Används för att lagra och spåra besök på flera webbplatser.',
  cookiesFacebookUniqueId:
    'Används för att lagra unik identifierare för din webbläsare som bland annat hjälper oss att skydda dig från bedrägerier.',
  cookiesFacebookDevicePixelRatio:
    'Används för att registrera enhetens pixelförhållande på din skärm och om du har aktiverat högkontrastläge eller inte, så att vi kan rendera våra webbplatser optimalt.',
  cookiesFacebookMarketing:
    'Används för att tillhandahålla annonsvisning eller retargeting.',
  cookiesGoogleDoubleClick:
    'Används av Google DoubleClick för att registrera och rapportera webbplatsanvändarens handlingar efter att ha sett eller klickat på en av annonsörens annonser i syfte att mäta effektiviteten av en annons och att presentera riktade annonser för användaren.',
  cookiesBingRefreshMuid: 'Indikerar om MUID ska uppdateras.',
  cookiesRomanceGuard:
    'Används för att upptäcka bedrägerier, spam, skadlig programvara.',
  cookiesTaboolaUniqueId:
    'Tilldelar ett unikt, uppdelat användar-ID som Taboola använder för attributions- och rapporteringssyften, och för att skräddarsy rekommendationer till denna specifika användare baserat på interaktioner med en annonsör eller utgivare.',
  cookiesSnapchatId: 'Används för att identifiera en besökare.',
  cookiesSnapchatTrackId:
    'Ställer in ett unikt ID för besökaren, som gör att tredjepartsannonsörer kan rikta in sig på besökaren med relevant reklam. Denna kopplingstjänst tillhandahålls av tredje parts annonshubbar, vilket underlättar budgivning i realtid för annonsörer.',
  cookiesSnapchatPixelId:
    'Används för att avgöra om en tagg från tredje part kommer att anropas i en Snap Ads Pixel.',
  cookiesVWOVisits: 'Används för att lagra unika besök.',
  cookiesVWOTest: 'Används för att läsa om cookies kan placeras.',
  cookiesVWOSafari:
    'Denna kaka är en burk med alla kakor. Den skapas för närvarande endast för webbläsaren Safari. I framtiden kommer det att ersätta alla VWO-kakor. OBS: Det faktiska utgångsdatumet för denna cookie är irrelevant eftersom den lagrar utgången av cookies som finns i den och fortsätter att löpa ut.',
  cookiesVWODS:
    'Denna cookie lagrar beständig data på besöksnivå för VWO Insights.',
  cookiesVWOExpiration: 'Beror på lagringsperioden för kontot.',
  cookiesVWOUniqueId:
    'Denna cookie genererar ett unikt ID för varje besökare och används för rapportsegmenteringsfunktionen i VWO. Det gör det också möjligt att se data på ett mer förfinat sätt.',
  cookiesVWOUniqueVisits:
    'Denna cookie beräknar unika besökares trafik på en webbplats.',
  cookiesAppsFlyer:
    'Vi använder den här tjänsten för att upptäcka användares enheter som iOS iPhone eller Android Phone för att visa banner för användare för att låta dem veta om de vill installera en inbyggd applikation från iStore eller Google Play Butik.',
  cookiesTikTok:
    'För att mäta och förbättra prestandan för dina reklamkampanjer och för att anpassa användarens upplevelse (inklusive annonser) på TikTok.',
  cookiesRaygun:
    'Raygun tillhandahåller fel-, krasch- och prestandaövervakning för mjukvaruteam.',
  name: 'Namn',
  description: 'Beskrivning',
  duration: 'Varaktighet',
  url: 'URL',
  domain: 'Domän',

  // email verification
  welcome: 'Välkommen',
  emailConfirmationTitle: 'Bekräfta din e-post för att hålla kontakten!',
  emailConfirmationDesc:
    'Din e-post är ännu inte bekräftad, så du tar för närvarande inte emot några e-postmeddelanden eller meddelanden!',
  weRecomend:
    'Vi rekommenderar att du klickar på knappen för att skicka om länken och sedan kollar din e-post.',
  resendConfirmation: 'SKICKA BEKRÄFTELSEMAILET IGEN',
  ifForAnyReason: 'Om du av någon anledning vill ändra din e-postadress, ',
  dontSeeIt: 'Ser du det inte?',
  andWeWillResend:
    'och vi skickar e-postmeddelandet igen omedelbart så att det blir lätt att hitta!',
  checkSpamFolder: 'Kontrollera skräppostmappen',
  ifYouDoNotSeeYourMessage:
    'Om du inte ser ditt meddelande i inkorgen, kontrollera skräppostmappen.',
  thenSelect: 'Välj sedan meddelandet och markera det som INTE SKRÄPPOST.',
  needHelp: 'Behöver du hjälp? ',
  ClickHereForMoreInfo: 'Klicka här för mer info',
  addUsToYouContacts: 'Lägg till oss i din Kontaktlista',
  beSureToAdd: 'Var noga med att lägga till',
  notifyEmail: 'notify@nearbynotifications.com',
  toYourAddressBook:
    'till din adressbok/kontaktlista så att dina meddelanden och flirtar kommer till din inkorg.',
  copiedToClipboard: 'Kopierade till Urklipp',
  cantWait:
    'Vi kan inte vänta med att hjälpa dig att hitta din perfekta match. Vi har tusentals medlemmar som väntar på att träffa dig...',
  seeYou: 'Vi ses på insidan!',
  emailConfirmationDecline:
    'Nej tack, jag vill inte skicka det nu, jag gör det senare.',
  emailConfirmationToast: 'Bekräftelselänk skickad. Kontrollera din e-post.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Lägg till ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' i din kontaktlista för att undvika att ',
  missingAnyMessage: 'MISSA några meddelanden!',
  contactsInfoDetails:
    'Lägg till ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' i din adressbok eller kontaktlista så att du inte missar några meddelanden eller flörtar.',
  openMessageStep:
    'Öppna ett meddelande från avsändaren som du vill spara som kontakt i Gmail.',
  hoverCursorStep:
    'Håll markören över avsändarens namn högst upp i e-postmeddelandet.',
  selectAddToContactsStep: 'Välj Lägg till i kontakter i popup-menyn.',
  resendConfirmationLinkText:
    'Klicka här för att skicka ditt bekräftelselänk igen',
  toMakeItEasier: 'så det blir lättare att hitta i din inkorg!',
  checkGmailInbox: 'KONTROLLERA DIN GMAIL-INBOX',

  // checkSpamFolder
  beSure: 'Se till att kontrollera',
  spamFolder: 'Skräppostmappen',
  ifYouDoNotSeeMessage: 'om du inte ser vårt meddelande i inkorgen!',
  spamFolderDetails:
    'Om du upptäcker att vårt meddelande felaktigt klassificerades som skräppost, kan du avmarkera meddelandet.',
  unmarkingAMessage:
    'Att avmarkera ett meddelande flyttar det automatiskt till din inkorg.',
  openSpamFolderStep:
    'Klicka på Skräppost på vänster sida av vilken sida som helst.',
  selectMessageStep: 'Välj meddelandet.',
  markAsNotSpamStep: "Klicka på 'Inte skräppost' högst upp på sidan.",

  // change email
  changeEmail: 'Byt e-post!',
  newEmailAddress: 'Ny e-postadress',
  currentEmailAddress: 'Nuvarande e-postadress',

  // cancel web subscription
  cancelVipMembership: 'Avsluta VIP-medlemskap',
  yesCancelVip: 'Ja, avsluta VIP-medlemskap',
  noKeepVip: 'Nej, behåll VIP-medlemskap',
  doYouWantToGiveUpVip:
    'Vill du verkligen ge upp alla dessa fantastiska funktioner?',
  cancelSubscriptionSuccess: 'Prenumerationen har avbrutits framgångsrikt.',
  resubscribeVip: 'Återprenumerera på VIP',
  weWillNotRenewYourSubscription:
    'Ditt abonnemang är för närvarande aktivt, dock har du avbrutit det. När ditt abonnemang löper ut kommer det inte att förnyas, och du kommer att förlora tillgången till premiumfunktioner. Du kan återprenumerera när som helst före utgången för att fortsätta njuta av dina förmåner.',
};
